import React, { ChangeEvent } from "react";
import BrowserService from "../../utilities/browserService";
import UserService from "../../utilities/userService";
import { setCurrentSearchSuggestion } from "../../utilities/utilities";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { unsafeCharRegex } from "wbm-inputs";
export interface ISearchInputProps {
  onSearchChange: (value: string) => void;
  hoveredSuggestion: number;
  suggestions: { value: string }[];
  onSuggestionNavigate: (value: number) => void;
  isMobile?: boolean;
  keyword: string;
  onSearchFocus: (value: boolean) => void;
  offset: number;
}

class SearchInput extends React.Component<ISearchInputProps> {
  constructor(props: ISearchInputProps) {
    super(props);

    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.onKeyDownHandler = this.onKeyDownHandler.bind(this);
  }

  onChangeHandler(event: ChangeEvent<HTMLInputElement>) {
    if (!unsafeCharRegex.test(event.target.value)) {
      this.props.onSearchChange(event.target.value);
    }
  }

  onKeyDownHandler(event: React.KeyboardEvent<HTMLInputElement>) {
    const keycode = event.keyCode ? event.keyCode : event.which;
    let preventDefault = false;

    if (keycode === 13 || event.key === "Enter") {
      if (this.props.hoveredSuggestion >= 0) {
        const suggestion = this.props.suggestions[this.props.hoveredSuggestion];
        setCurrentSearchSuggestion(suggestion.value);
        this.props.onSearchChange(suggestion.value);
      }
    }

    if (keycode === 38) {
      preventDefault = true;
      this.props.onSuggestionNavigate(-1);
    }

    if (keycode === 40) {
      preventDefault = true;
      this.props.onSuggestionNavigate(1);
    }

    if (preventDefault) {
      event.preventDefault();
    }
  }

  render() {
    return (
      <input
        className={`border  d-inline-block ${
          this.props.isMobile ? "search-input-mobile" : "search-input"
        } ${!BrowserService.transitionsSupported() ? "no-animations" : ""}`}
        name="Keyword"
        id="Keyword"
        value={this.props.keyword}
        onChange={this.onChangeHandler}
        onFocus={() => {
          this.props.onSearchFocus(true);
        }}
        onClick={() => {
          this.props.onSearchFocus(true);
        }}
        onBlur={() => {
          this.props.onSearchFocus(false);
        }}
        disabled={!UserService.displayUserInfo()}
        onKeyDown={this.onKeyDownHandler}
        placeholder="Search W.B. Mason"
        style={
          this.props.isMobile
            ? {}
            : {
                paddingLeft: this.props.offset + 10,
              }
        }
        maxLength={250}
        aria-label="Keyword"
      ></input>
    );
  }
}

export default SearchInput;
